var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F5F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8217 8.29443V11.2911C17.8217 11.6969 17.9833 12.0869 18.2717 12.3744C18.5607 12.6622 18.9521 12.8238 19.36 12.8236H22.7975",
    stroke: "#8898A6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3725 12.3727H15.0933M12.3725 16.0002H19.6275M12.3725 19.6277H19.6275M22.875 13.1402V20.2802C22.8585 20.7472 22.7496 21.2063 22.5548 21.6311C22.3601 22.0559 22.0831 22.4379 21.74 22.7552C21.3966 23.0739 20.9938 23.3219 20.5545 23.4849C20.1153 23.6479 19.6482 23.7227 19.18 23.7052H12.855C12.3839 23.7267 11.9133 23.6551 11.47 23.4943C11.0267 23.3336 10.6195 23.0869 10.2717 22.7685C9.92522 22.4504 9.64545 22.0666 9.44861 21.6394C9.25176 21.2123 9.14176 20.7502 9.125 20.2802V11.7185C9.14155 11.2515 9.25035 10.7924 9.44515 10.3676C9.63995 9.94281 9.91688 9.56078 10.26 9.24352C10.6034 8.92479 11.0062 8.67684 11.4455 8.51383C11.8847 8.35083 12.3518 8.27597 12.82 8.29352H17.5817C18.3086 8.29095 19.0102 8.55991 19.5492 9.04769L22.0158 11.316C22.279 11.5428 22.4916 11.8224 22.6396 12.1366C22.7876 12.4509 22.8678 12.7929 22.875 13.1402Z",
    stroke: "#8898A6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic-file.9e70d3bed0d3ab25492e2d1107304574.svg";
export { ForwardRef as ReactComponent };